import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgLock = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.75 8.75h-3.5V6.125a5.25 5.25 0 1 0-10.5 0V8.75h-3.5A1.75 1.75 0 0 0 3.5 10.5v12.25a1.75 1.75 0 0 0 1.75 1.75h17.5a1.75 1.75 0 0 0 1.75-1.75V10.5a1.75 1.75 0 0 0-1.75-1.75ZM10.5 6.125a3.5 3.5 0 1 1 7 0V8.75h-7V6.125ZM22.75 22.75H5.25V10.5h17.5v12.25Zm-7.438-6.125a1.313 1.313 0 1 1-2.625 0 1.313 1.313 0 0 1 2.626 0Z" />
  </svg>
);
export default SvgLock;
